import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as cursadasService from '../../services/cursadas/cursadasService';
import {
  classifyCursadasError,
  toUpdateCursadaPayload,
  validateCursadaForm,
  validateDictadoMatch
} from '../../services/cursadas/cursadasDto';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { LookupPeriodoCursada } from '../PeriodoCursada/LookupPeriodoCursada';

export class UpdateCursada extends Component {
  static displayName = UpdateCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: "",
      name: "",
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: "",
      details: this.props.match.params.details,
      carrera: { carreraCod: "", carreraNombre: "" },
      periodoCursada: { codigo: 0, descripcion: "" },
      code: "",
      name: "",
      anioDictado: "",
      dictado: "",
      practica: "",
      showLookupStudent: false,
      showLookupCarreras: false
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleStudentHideLookup = this.handleStudentHideLookup.bind(this);
    this.handleShowStudentLookup = this.handleShowStudentLookup.bind(this);
    this.handleShowCarreraLookup = this.handleShowCarreraLookup.bind(this);
    this.handleSelectStudentItem = this.handleSelectStudentItem.bind(this);
    this.handleSelectCarreraItem = this.handleSelectCarreraItem.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWCursada');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    var okToSave = validateCursadaForm({
      materiaPresent: this.state.carrera.carreraNombre.length > 0,
      periodoPresent: this.state.periodoCursada.descripcion.length > 0
    });
    var dictadoCorrecto = validateDictadoMatch(this.state.carrera.dictado, this.state.periodoCursada.dictado);

    if (okToSave && dictadoCorrecto) {
      this.saveStudent();
    } else {
      var errorMessage = "";
      if (!okToSave) {
        errorMessage = "Todos los campos son obligatorios";
      } else {
        errorMessage = "La materia seleccionada no se dicta en el período seleccionado";
      }
      this.setState({ showErrorMessage: true, errorMessage: errorMessage });
    }
  }

  handleHideLookup = () => {
    this.setState({ showLookupCarreras: false });
  }

  handleStudentHideLookup = () => {
    this.setState({ showLookupStudent: false });
  }

  handleShowStudentLookup = () => {
    this.setState({ showLookupStudent: true });
  }

  handleShowCarreraLookup = () => {
    this.setState({ showLookupCarreras: true });
  }

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.setState(
      {
        periodoCursada: {
          codigo: studentProperties[0],
          descripcion: studentProperties[1] + "-" + studentProperties[2],
          dictado: studentProperties[3].trim(),
        },
        showLookupStudent: false
      });
  }

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupCarreras: false,
      carrera: {
        carreraCodigo: carreraProperties[0],
        carreraNombre: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
        dictado: carreraProperties[4].trim(),
      }
    });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-cur" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Cursada' : 'Modificar Cursada';
    const { loading } = this.state;
    const materiaDisplay = this.state.carrera.carreraNombre.trim();
    const periodoDisplay = this.state.periodoCursada.descripcion.trim();

    return (
      <div className="md-page md-update-cursada">
        <Link className="md-page__back-link" to="/md-cur">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la cursada.'
            : 'Actualice la materia o el período de cursada y guarde los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{materiaDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de cursada</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowStudentLookup}>
                  Seleccionar período de cursada
                </button>
              ) : null}
              <div className="md-page__field-readonly">{periodoDisplay}</div>
            </div>
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupCarreras ? (
          <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookupStudent ? (
          <LookupPeriodoCursada selectItem={this.handleSelectStudentItem} hideLookup={this.handleStudentHideLookup} />
        ) : null}
      </div>
    );
  }

  getPeriodoCursada(periodoCursadaDescripcion) {

    if (periodoCursadaDescripcion == "1") {
      return "Primer Cuatrimestre";
    } else {
      if (periodoCursadaDescripcion == "2") {
        return "Segundo Cuatrimestre";
      }
      else {
        return "Anual";
      }
    }
  }

  async populateData() {
    try {
      const returnModel = await cursadasService.getCursada(this.state.id);
      const materiaCodigo = (returnModel.materiaCarreraCodigo || returnModel.materiaCarreraCod || '').trim();
      const materiaNombre = (returnModel.materiaNombre || '').trim();
      const carreraNombre = (returnModel.carreraNombre || '').trim();
      const materiaDisplay = [materiaCodigo, materiaNombre, carreraNombre].filter(Boolean).join(' - ');
      const anioAcademico = (returnModel.anioAcademicoDescripcion || '').trim();

      this.setState({
        errorMessage: "",
        showErrorMessage: false,
        carrera: {
          carreraNombre: materiaDisplay,
          carreraCodigo: returnModel.materiaCarreraCod,
          dictado: returnModel.materiaDictado
        },
        periodoCursada: {
          codigo: returnModel.periodoCursadaCod,
          descripcion: this.getPeriodoCursada(returnModel.periodoCursadaDescripcion)
            + (anioAcademico ? `-${anioAcademico}` : ''),
          dictado: returnModel.periodoCursadaDescripcion
        }
      });
    } catch (error) {
      const outcome = classifyCursadasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ showErrorMessage: true, errorMessage });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await cursadasService.saveCursada(
        toUpdateCursadaPayload({
          cursadaCod: parseInt(this.state.id, 10),
          materiaCarreraCod: this.state.carrera.carreraCodigo.trim(),
          periodoCursadaCod: parseInt(this.state.periodoCursada.codigo, 10)
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCursadasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, showErrorMessage: true, errorMessage });
    }
  }
}
